<template>
  <div class="">
    <!--<br />-->
    <!-- <div class="container">
      <i class="fas ml-2 text-right fa-ellipsis-v"></i>
      <ul class="tabs float-left">
        <li @click="firstTab" class="tab-list">Project Details</li>
        <li @click="secondTab" class="tab-list">Proposals</li>
      </ul>
    </div>-->
    <br />
    <br />
    <!-- Sppiner -->
    <div
      v-if="projectLoading"
      class="spinner-grow text-primary"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
    <!-- project -->
    <div v-else class="container">
      <div class="bodySection">
        <div class="row  justify-content-left">
          <div class="col-md-8">
            <div class="shadow  p-4  projectSection">
              <!--   Sppiner 
              <div v-if="projectsLoaded" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div> -->
              <div class="row justify-content-left">
                <div class="col-md-8">
                  <h3 class="title text-left">
                    <strong>{{ project.title }}</strong>
                  </h3>
                  <p class="text-dark text-left created_at">
                    <i class="far mr-2 fa-clock"></i>
                    {{ project.created_at }}
                  </p>
                  <!-- <a class="float-left" :href="'mailto:' + project.user_email">
                    {{ project.user_email }}
                  </a>-->
                </div>
                <div class="col-md-4">
                  <h5 class="budget text-right">
                    <strong>{{ project.budget }}</strong>
                  </h5>
                </div>
              </div>
              <br />
              <!-- <br /> -->
              <div v-html="project.description" class="body text-left">
                <!--{{ project.description }}-->
              </div>
              <br />
              <div class="float-left">
                <!--<p class="text-left">Requirements:</p>-->
                <h4
                  v-for="skill in project.skills"
                  :key="skill"
                  class="skills badge badge-dark p-2 mr-2"
                >
                  {{ skill }}
                </h4>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="userInfoSection shadow  p-4">
              <p class="text-left  mb-4 credentials Bold">
                <i class="fas mr-2 fx-3 fa-info-circle"></i>
                About the employer:
              </p>
              <p class="text-left notBold credentials">
                <!-- <i class="fas mx-2 fa-user"></i>-->
                {{ " Name : " }}
                <strong class="Bold text-dark">
                  {{ "  " + userInfo.name }}
                </strong>
              </p>
              <p class="text-left notBold credentials">
                <!--<i class="fas mx-2 fa-inbox"></i>-->
                Email :
                <strong class="text-dark Bold">
                  {{ "  " + userInfo.email }}
                </strong>
              </p>
              <p class="text-left notBold credentials">
                <!-- <i class="fas mx-2 fa-map-marker-alt"></i>-->
                {{ " State : " }}
                <strong class="text-dark Bold">
                  {{ "  " + userInfo.city + "," + userInfo.country }}
                </strong>
              </p>
              <p class="text-left notBold credentials">
                <!--<i class="fas mx-2 fa-phone"></i>-->
                {{ " Phone : " }}
                <strong class="text-dark Bold">
                  {{ "  " + userInfo.phone }}
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- project -->
      <br />
      <!-- add porposal -->
      <div class="proposalsSection">
        <!--display-none added if tab system active-->
        <div v-if="token" class="bg-light shadow p-4  porposalInput">
          <p class="text-left m-2">Add Your Proposal</p>
          <div class="float-left">
            <input
              type="text"
              class="descriptionInput form-control add-description"
              name="description"
              placeholder="Describe Your Proposal"
              v-model="description"
            />
            <select
              class="form-control budgetInput my-2 add-budget"
              name="budget"
              v-model="budget"
            >
              <option value="10$~100$">10$~100$</option>
              <option value="100$~500$">100$~500$</option>
              <option value="500$~1000$">500$~1000$</option>
              <option value="1000$~2000$">1000$~2000$</option>
              <option value="2000$~3500$">2000$~3500$</option>
              <option value="3500$~4500$">3500$~4500$</option>
              <option value="4500$~+5500$">4500$~+5500$</option>
            </select>
            <button
              @click="addProposal()"
              class="btn shadow border add-proposal primary text-white"
            >
              Post Proposal
            </button>
          </div>
        </div>
        <!-- Alert Msg -->
        <div v-else class="alert alert-info  text-left">
          <i class="fas mr-2 fx-3 fa-info-circle"></i>Log In Required To Submit
          Your Proposal!
        </div>
        <!-- add porposal -->
        <br />
        <h5 class="text-dark text-left ">
          Proposals: <strong>{{ proposals.length }}</strong>
        </h5>
        <br />
        <!-- porposals -->
        <div
          v-for="(proposal, index) in proposals"
          :key="proposal"
          class="shadow proposal  p-4 text-left"
        >
          <div class="row">
            <div class="col-md-6">
              <p class="email text-left ">{{ proposal.user_email }}</p>
              <p class="text-dark text-left created_at">
                <i class="far mr-2 fa-clock"></i>
                {{ proposal.created_at }}
              </p>
            </div>
            <div class="col-md-6">
              <h5 class="budget text-right ">
                <strong>{{ proposal.budget }}</strong>
              </h5>
            </div>
          </div>
          <p class="body">
            {{ proposal.description }}
          </p>
          <a
            data-toggle="tooltip"
            data-placement="top"
            title="Contact Via Email"
            :href="'mailto:' + proposal.user_email"
            class="primary float-right btn text-white"
            >Contact</a
          >
          <!-- If the proposal of the user proposal.user_email === token.email -->
          <!-- edit and update proposal element goes here -->
          <div
            v-if="decoded_token && decoded_token.email === proposal.user_email"
            class="userOwn"
          >
            <button
              class="btn text-dark float-right dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Menu
            </button>
            <div
              class="dropdown-menu shadow"
              aria-labelledby="dropdownMenuButton"
            >
              <br />
              <ul class="proposal-menu">
                <li
                  class="dropdown-item"
                  data-toggle="modal"
                  :data-target="'#editModal' + index"
                  data-whatever="@getbootstrap"
                >
                  Update
                </li>
                <li
                  class=" dropdown-item"
                  style="color:red;"
                  data-toggle="modal"
                  :data-target="'#deleteModal' + index"
                  data-whatever="@getbootstrap"
                >
                  Delete
                </li>
              </ul>
            </div>
          </div>
          <!-- Edit Modal -->
          <div
            v-if="decoded_token && decoded_token.email === proposal.user_email"
            class="modal fade"
            :id="'editModal' + index"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Update your proposal
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div v-if="err" class="alert red text-white">
                    {{ errMsg }}
                  </div>
                  <div class="form">
                    <div class="form-group">
                      <label for="message-text" class="col-form-label"
                        >Description:</label
                      >
                      <textarea
                        class="form-control "
                        :id="'update-description' + index"
                        :value="proposal.description"
                        name="description"
                      >
                      </textarea>
                    </div>
                    <div class="form-group">
                      <label for="recipient-name" class="col-form-label"
                        >Budget</label
                      >
                      <select
                        class="form-control "
                        :id="'update-budget' + index"
                        :value="proposal.budget"
                        name="budget"
                      >
                        <option value="10$~100$">10$~100$</option>
                        <option value="100$~500$">100$~500$</option>
                        <option value="500$~1000$">500$~1000$</option>
                        <option value="1000$~2000$">1000$~2000$</option>
                        <option value="2000$~3500$">2000$~3500$</option>
                        <option value="3500$~4500$">3500$~4500$</option>
                        <option value="4500$~+5500$">4500$~+5500$</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    @click="updateProposal(proposal._id, index)"
                    class="btn update-btn text-white primary"
                    :id="'update-btn' + index"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Edit Modal -->
          <!-- Delete Modal -->
          <div
            v-if="decoded_token && decoded_token.email === proposal.user_email"
            class="modal fade"
            :id="'deleteModal' + index"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Are you sure you want to delete this proposal?
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  ...
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    @click="deleteProposal(proposal._id, index)"
                    class="btn delete-btn text-white red"
                    :id="'delete-btn' + index"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Delete Modal -->
        </div>
        <!-- No Proposals Message Goes Here ()-->
        <!-- If user already logged in  -->
        <div
          v-if="proposals.length == 0 && token"
          class="alert alert-warning text-left"
        >
          <i class="fas mr-2 fx-3 fa-info-circle"></i>Be the first one to submit
          a proposal!
        </div>
        <br>
        <br>
        <!-- If not  -->
        <div v-if="proposals.length == 0" class="text-dark">
          <center>
                <svg
                  id="f20e0c25-d928-42cc-98d1-13cc230663ea"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="250"
                  height="250"
                  viewBox="0 0 820.16 780.81"
                >
                  <defs>
                    <linearGradient
                      id="07332201-7176-49c2-9908-6dc4a39c4716"
                      x1="539.63"
                      y1="734.6"
                      x2="539.63"
                      y2="151.19"
                      gradientTransform="translate(-3.62 1.57)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0" stop-color="gray" stop-opacity="0.25" />
                      <stop
                        offset="0.54"
                        stop-color="gray"
                        stop-opacity="0.12"
                      />
                      <stop offset="1" stop-color="gray" stop-opacity="0.1" />
                    </linearGradient>
                    <linearGradient
                      id="0ee1ab3f-7ba2-4205-9d4a-9606ad702253"
                      x1="540.17"
                      y1="180.2"
                      x2="540.17"
                      y2="130.75"
                      gradientTransform="translate(-63.92 7.85)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                    <linearGradient
                      id="abca9755-bed1-4a97-b027-7f02ee3ffa09"
                      x1="540.17"
                      y1="140.86"
                      x2="540.17"
                      y2="82.43"
                      gradientTransform="translate(-84.51 124.6) rotate(-12.11)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                    <linearGradient
                      id="2632d424-e666-4ee4-9508-a494957e14ab"
                      x1="476.4"
                      y1="710.53"
                      x2="476.4"
                      y2="127.12"
                      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                    <linearGradient
                      id="97571ef7-1c83-4e06-b701-c2e47e77dca3"
                      x1="476.94"
                      y1="156.13"
                      x2="476.94"
                      y2="106.68"
                      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                    <linearGradient
                      id="7d32e13e-a0c7-49c4-af0e-066a2f8cb76e"
                      x1="666.86"
                      y1="176.39"
                      x2="666.86"
                      y2="117.95"
                      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
                      xlink:href="#07332201-7176-49c2-9908-6dc4a39c4716"
                    />
                  </defs>
                  <title>no data</title>
                  <rect
                    x="317.5"
                    y="142.55"
                    width="437.02"
                    height="603.82"
                    transform="translate(-271.22 62.72) rotate(-12.11)"
                    fill="#e0e0e0"
                  />
                  <g opacity="0.5">
                    <rect
                      x="324.89"
                      y="152.76"
                      width="422.25"
                      height="583.41"
                      transform="translate(-271.22 62.72) rotate(-12.11)"
                      fill="url(#07332201-7176-49c2-9908-6dc4a39c4716)"
                    />
                  </g>
                  <rect
                    x="329.81"
                    y="157.1"
                    width="411.5"
                    height="570.52"
                    transform="translate(-270.79 62.58) rotate(-12.11)"
                    fill="#fafafa"
                  />
                  <rect
                    x="374.18"
                    y="138.6"
                    width="204.14"
                    height="49.45"
                    transform="translate(-213.58 43.93) rotate(-12.11)"
                    fill="url(#0ee1ab3f-7ba2-4205-9d4a-9606ad702253)"
                  />
                  <path
                    d="M460.93,91.9c-15.41,3.31-25.16,18.78-21.77,34.55s18.62,25.89,34,22.58,25.16-18.78,21.77-34.55S476.34,88.59,460.93,91.9ZM470.6,137A16.86,16.86,0,1,1,483.16,117,16.66,16.66,0,0,1,470.6,137Z"
                    transform="translate(-189.92 -59.59)"
                    fill="url(#abca9755-bed1-4a97-b027-7f02ee3ffa09)"
                  />
                  <rect
                    x="375.66"
                    y="136.55"
                    width="199.84"
                    height="47.27"
                    transform="translate(-212.94 43.72) rotate(-12.11)"
                    class="dynamic-svg"
                    fill="#6c63ff"
                  />
                  <path
                    d="M460.93,91.9a27.93,27.93,0,1,0,33.17,21.45A27.93,27.93,0,0,0,460.93,91.9ZM470.17,135a16.12,16.12,0,1,1,12.38-19.14A16.12,16.12,0,0,1,470.17,135Z"
                    transform="translate(-189.92 -59.59)"
                    class="dynamic-svg"
                    fill="#6c63ff"
                  />
                  <rect
                    x="257.89"
                    y="116.91"
                    width="437.02"
                    height="603.82"
                    fill="#e0e0e0"
                  />
                  <g opacity="0.5">
                    <rect
                      x="265.28"
                      y="127.12"
                      width="422.25"
                      height="583.41"
                      fill="url(#2632d424-e666-4ee4-9508-a494957e14ab)"
                    />
                  </g>
                  <rect
                    x="270.65"
                    y="131.42"
                    width="411.5"
                    height="570.52"
                    fill="#fff"
                  />
                  <rect
                    x="374.87"
                    y="106.68"
                    width="204.14"
                    height="49.45"
                    fill="url(#97571ef7-1c83-4e06-b701-c2e47e77dca3)"
                  />
                  <path
                    d="M666.86,118c-15.76,0-28.54,13.08-28.54,29.22s12.78,29.22,28.54,29.22,28.54-13.08,28.54-29.22S682.62,118,666.86,118Zm0,46.08a16.86,16.86,0,1,1,16.46-16.86A16.66,16.66,0,0,1,666.86,164Z"
                    transform="translate(-189.92 -59.59)"
                    fill="url(#7d32e13e-a0c7-49c4-af0e-066a2f8cb76e)"
                  />
                  <rect
                    x="377.02"
                    y="104.56"
                    width="199.84"
                    height="47.27"
                    class="dynamic-svg"
                    fill="#6c63ff"
                  />
                  <path
                    d="M666.86,118a27.93,27.93,0,1,0,27.93,27.93A27.93,27.93,0,0,0,666.86,118Zm0,44.05A16.12,16.12,0,1,1,683,145.89,16.12,16.12,0,0,1,666.86,162Z"
                    transform="translate(-189.92 -59.59)"
                    class="dynamic-svg"
                    fill="#6c63ff"
                  />
                  <g opacity="0.5">
                    <rect
                      x="15.27"
                      y="737.05"
                      width="3.76"
                      height="21.33"
                      fill="#47e6b1"
                    />
                    <rect
                      x="205.19"
                      y="796.65"
                      width="3.76"
                      height="21.33"
                      transform="translate(824.47 540.65) rotate(90)"
                      fill="#47e6b1"
                    />
                  </g>
                  <g opacity="0.5">
                    <rect
                      x="451.49"
                      width="3.76"
                      height="21.33"
                      fill="#47e6b1"
                    />
                    <rect
                      x="641.4"
                      y="59.59"
                      width="3.76"
                      height="21.33"
                      transform="translate(523.63 -632.62) rotate(90)"
                      fill="#47e6b1"
                    />
                  </g>
                  <path
                    d="M961,832.15a4.61,4.61,0,0,1-2.57-5.57,2.22,2.22,0,0,0,.1-.51h0a2.31,2.31,0,0,0-4.15-1.53h0a2.22,2.22,0,0,0-.26.45,4.61,4.61,0,0,1-5.57,2.57,2.22,2.22,0,0,0-.51-.1h0a2.31,2.31,0,0,0-1.53,4.15h0a2.22,2.22,0,0,0,.45.26,4.61,4.61,0,0,1,2.57,5.57,2.22,2.22,0,0,0-.1.51h0a2.31,2.31,0,0,0,4.15,1.53h0a2.22,2.22,0,0,0,.26-.45,4.61,4.61,0,0,1,5.57-2.57,2.22,2.22,0,0,0,.51.1h0a2.31,2.31,0,0,0,1.53-4.15h0A2.22,2.22,0,0,0,961,832.15Z"
                    transform="translate(-189.92 -59.59)"
                    fill="#4d8af0"
                    opacity="0.5"
                  />
                  <path
                    d="M326.59,627.09a4.61,4.61,0,0,1-2.57-5.57,2.22,2.22,0,0,0,.1-.51h0a2.31,2.31,0,0,0-4.15-1.53h0a2.22,2.22,0,0,0-.26.45,4.61,4.61,0,0,1-5.57,2.57,2.22,2.22,0,0,0-.51-.1h0a2.31,2.31,0,0,0-1.53,4.15h0a2.22,2.22,0,0,0,.45.26,4.61,4.61,0,0,1,2.57,5.57,2.22,2.22,0,0,0-.1.51h0a2.31,2.31,0,0,0,4.15,1.53h0a2.22,2.22,0,0,0,.26-.45A4.61,4.61,0,0,1,325,631.4a2.22,2.22,0,0,0,.51.1h0a2.31,2.31,0,0,0,1.53-4.15h0A2.22,2.22,0,0,0,326.59,627.09Z"
                    transform="translate(-189.92 -59.59)"
                    fill="#fdd835"
                    opacity="0.5"
                  />
                  <path
                    d="M855,127.77a4.61,4.61,0,0,1-2.57-5.57,2.22,2.22,0,0,0,.1-.51h0a2.31,2.31,0,0,0-4.15-1.53h0a2.22,2.22,0,0,0-.26.45,4.61,4.61,0,0,1-5.57,2.57,2.22,2.22,0,0,0-.51-.1h0a2.31,2.31,0,0,0-1.53,4.15h0a2.22,2.22,0,0,0,.45.26,4.61,4.61,0,0,1,2.57,5.57,2.22,2.22,0,0,0-.1.51h0a2.31,2.31,0,0,0,4.15,1.53h0a2.22,2.22,0,0,0,.26-.45,4.61,4.61,0,0,1,5.57-2.57,2.22,2.22,0,0,0,.51.1h0a2.31,2.31,0,0,0,1.53-4.15h0A2.22,2.22,0,0,0,855,127.77Z"
                    transform="translate(-189.92 -59.59)"
                    fill="#fdd835"
                    opacity="0.5"
                  />
                  <circle
                    cx="812.64"
                    cy="314.47"
                    r="7.53"
                    fill="#f55f44"
                    opacity="0.5"
                  />
                  <circle
                    cx="230.73"
                    cy="746.65"
                    r="7.53"
                    fill="#f55f44"
                    opacity="0.5"
                  />
                  <circle
                    cx="735.31"
                    cy="477.23"
                    r="7.53"
                    fill="#f55f44"
                    opacity="0.5"
                  />
                  <circle
                    cx="87.14"
                    cy="96.35"
                    r="7.53"
                    fill="#4d8af0"
                    opacity="0.5"
                  />
                  <circle
                    cx="7.53"
                    cy="301.76"
                    r="7.53"
                    fill="#47e6b1"
                    opacity="0.5"
                  />
                </svg>
              </center>
        </div>
        <br />
        <br />
        <!-- porposals -->
      </div>
    </div>
    <div class="footerApp">
      <footerApp></footerApp>
    </div>
  </div>
</template>
<!-- // - user_id,
// - project_id,
// - description,
// - budget -->

<script>
import footerApp from "../components/footer.vue";
// IMPORT LINKS FILE
const link = require("../.././api.links.config.js");
import VueJwtDecode from "vue-jwt-decode";
//
export default {
  name: "project",
  components: {
    footerApp
  },

  data() {
    return {
      token: window.localStorage.getItem("access-token") || false, // TOKEN

      decoded_token: null,

      project_id: this.$route.params.id,

      err: false,

      errMsg: null,

      project: null,

      proposals: null,

      userInfo: null,

      projectLoading: true,
      // projectsLoaded : true,
      description: null,

      budget: "10$~100$" // Default Value
    };
  },
  created() {
    // SET SCROLL LEVEL TO 0 WHICH MEANS TO THE TOP
    window.scrollTo(0, 0);
    // CHECK IF TOKEN EXIST
    if (this.token) {
      // DECODE TOKEN FOR RECOGNIZE THE USER PROPOSAL
      // FOR LET HIM UPDATE PROPOSAL
      this.decoded_token = VueJwtDecode.decode(this.token);
    } else {
      // SET PROPOSAL'S MENU TO FALSE
      // FOR PREVENT UPDATE ANOTHER USER'S PROPOSAL
    }
    // Fetch Data Stuff Over Here...
    this.$http({
      url: link.baselink + `/project/get/${this.project_id}`,
      method: "get"
    })
      .then(res => {
        // PROCCESS DATA
        const project_data = {
          //
          _id: res.data.Project._id,
          //
          title: res.data.Project.title,
          //
          user_email: res.data.Project.user_email,
          //
          description: res.data.Project.description,
          //
          skills: res.data.Project.skills.split(","),
          //
          budget: res.data.Project.budget
        };

        // PASS DATA TO GLOBAL VARIABLES
        this.project = project_data;
        this.proposals = res.data.Proposals;
        this.userInfo = res.data.userInfo;

        // SET THE LOADING SPINNETR OFF BY SET THIS VARIABLE BELOW TO TRUE
        this.projectLoading = false;
      })
      .catch(err => {
        // Something goes here...
        alert(err.message);
      });
  },
  methods: {
    // UPDATE PROPOSAL
    updateProposal: function(id, index) {
      // GRAB THE DATA
      const description = document.querySelector("#update-description" + index)
        .value;
      const budget = document.querySelector("#update-budget" + index).value;

      // VERIFY
      if (description === "" || budget === "") {
        // SHOW ERROR MESSAGE
        this.err = true;
        this.errMsg = "You Must Fill All The Inputs!";

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else {
        // CHANGE BTN CONTENT
        document.querySelector(
          "#update-btn" + index
        ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-white" role="status" aria-hidden="true"></span>
              Please Wait...`;

        // UPDATE DATA
        this.$http({
          url: link.baselink + `/proposal/update/${id}/${this.token}`,
          method: "post",
          data: { description, budget } /*Temporary*/
        }).then(res => {
          // CHECK IF DATA WAS UPDATED
          if (res.data.updated === true) {
            // RELOAD WINDOW
            window.location.reload();
          } else {
            // CHANGE BTN CONTENT
            document.querySelector("#update-btn" + index).innerHTML = `Update`;

            // SHOW ERROR MESSAGE
            this.err = true;
            this.errMsg = "Sorry Something Went Wrong!";

            // HIDE ALERT AFTER 3 SECONDS
            window.setInterval(() => {
              this.errMsg = null;
              this.err = false;
            }, 5000);
          }
        });
      }
    },
    // DELETE PROPOSAL
    deleteProposal: function(id, index) {
      // CHANGE BTN CONTENT
      document.querySelector(
        "#delete-btn" + index
      ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-white" role="status" aria-hidden="true"></span>
          Please Wait...`;

      // DELETE THE PROPOSAL
      this.$http({
        url: link.baselink + `/proposal/delete/${id}/${this.token}`,
        method: "post",
        data: null /*Permanent*/
      }).then(res => {
        // CHECK IF PROPOSAL DELETED
        if (res.data.deleted === true) {
          // RELOAD WINDOW
          window.location.reload();
        } else {
          // CHANGE BTN CONTENT
          document.querySelector("#delete-btn" + index).innerHTML = `Delete`;

          // SHOW ERROR MESSAGE
          this.err = true;
          this.errMsg = "Sorry Something Went Wrong!";

          // HIDE ALERT AFTER 3 SECONDS
          window.setInterval(() => {
            this.errMsg = null;
            this.err = false;
          }, 5000);
        }
      });
      // .catch((err)=>{

      // })
    },
    // TABS SYSTEM FUNCTIONALITY
    /*firstTab() {
      // alert(' Hello WOrld')
      document.querySelector(".bodySection").classList.add("display-block");
      document.querySelector(".bodySection").classList.remove("display-none");
      document.querySelector(".proposalsSection").classList.add("display-none");

      document
        .querySelector(".proposalsSection")
        .classList.remove("display-block");
    },

    secondTab() {
      // alert(' Hello WOrld')
      document.querySelector(".bodySection").classList.add("display-none");
      document.querySelector(".bodySection").classList.remove("display-block");
      document
        .querySelector(".proposalsSection")
        .classList.add("display-block");

      document
        .querySelector(".proposalsSection")
        .classList.remove("display-none");
    },*/
    // add Proposal
    addProposal() {
      // VALIDATE INPUTS
      if (this.description === null) {
        document.querySelector(".add-description").style.border =
          ".5px solid red";
      } else if (this.budget === null) {
        document.querySelector(".add-budget").style.border = ".5px solid red";
      } else {
        // CHANGE BTN CONTENT
        document.querySelector(
          ".add-proposal"
        ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-white" role="status" aria-hidden="true"></span>
        Please Wait...`;

        // ADD PROPOSAL
        this.$http({
          url: link.baselink + `/proposal/post/${this.token}`,
          method: "post",
          data: {
            project_id: this.project_id,
            description: this.description,
            budget: this.budget
          }
        })
          .then(res => {
            if (res.data.posted) {
              // RELOAD WINDOW
              window.location.reload();
            }
            // console.log(res);
          })
          .catch(err => {
            // Something Goes Here...
            // console.log(err);
            alert(err.message);
          });
      }
    }
  }
};
</script>

<style lang="css" scoped>
.body {
  font-weight: 100;
}
.container {
  color: var(--text-color);
}
.skills {
  font-size: 10px;
}
.projectSection {
  padding-top: 20px;
  padding-bottom: 60px !important;
  border-left: 5px solid var(--bg-color-dark);
  border-radius: 3px;
}
.tabs-navbar {
  height: 40px;
  background-color: var(--tabs-color);
}
.tabs {
  color: white;
  padding-top: 8px;
}
.tabs li {
  display: inline;
  margin-right: 8px;
  cursor: pointer;
}
.display-block {
  display: block;
}
.display-none {
  display: none;
}
.descriptionInput {
  width: 500px;
  display: inline;
  /* height: 100px;*/
  margin: 5px;
}
.porposalInput {
  border-left: 5px solid var(--bg-color-dark);
  margin: 0 auto;
  padding-bottom: 80px !important;
  /*margin-bottom: 100px !important;*/
}
.primary {
  background-color: var(--primary-color) !important;
}
.budgetInput {
  width: 150px;
  display: inline;
  margin: 5px;
}
.add-proposal {
  display: inline;
  margin: 5px;
}
.proposal {
  /*height: 100px!important;*/
  padding-top: 20px !important;
  padding-bottom: 60px !important;
  border-left: 5px solid var(--primary-color);
  border-radius: 3px;
}
.proposal:hover {
  border-left: 5px solid var(--bg-color-dark) !important;
  transition: all 0.2s !important;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 4px 18px 0 rgba(0, 0, 0, 0.19) !important;
}
.body {
  font-weight: 100;
}
.inline {
  display: inline;
}
.tab-list {
  color: var();
  cursor: pointer;
  display: inline;
  padding: 5px;
}
.tabs {
  list-style: none;
  color: var(--text-color);
  font-weight: bolder;
}
.tab-list:hover {
  /*background-color: var(--main-btn-color);*/
  color: var(--primary-color);
  transition: all 0.2s ease-out;
}
.red {
  background-color: var(--dan-ger);
}
.primary {
  background-color: var(--primary-color);
}
.dynamic-svg {
  fill: var(--primary-color) !important;
}
.credentials {
  margin: 5px !important;
} /*
.notBold {
  font-weight: 100;
}
.Bold {
  font-weight: bolder !important;
}*/
.text-dark {
  color: rgba(0, 0, 0, 0.7) !important;
}
.userInfoSection {
  border-left: 5px solid var(--bg-color-dark);
  border-radius: 3px;
}
.fa-ellipsis-v {
  font-size: 12px;
  color: var(--text-color);
}
.created_at {
  font-size: 12px;
  font-weight: 200;
}
.proposal-menu {
  text-decoration: none;
  list-style: none;
  padding-left: 0 !important;
}
.proposal-menu li {
  cursor: pointer;
}
.dropdown-menu {
  padding: 0 !important;
}
.footerApp {
  margin-top: 100px;
}
.border {
/*  padding-left: 30px!important;
  padding-right: 30px!important;*/
  border-radius: 3px;
}
@media only screen and (max-width: 600px) {
  .container {
    margin: 0 auto !important;
    width: 100% !important;
  }
  .descriptionInput {
    width: 100%;
  }
  .porposalInput {
    padding: 10px !important;
    height: 250px !important;
  }
  .budgetInput {
    width: 100%;
  }
  .add-proposal {
    width: 100%;
  }
  .budget {
    text-align: left !important;
  }
  .proposal {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .title {
    font-size: 20px;
  }
  .budget {
    float: left;
  }
}
@media only screen and (max-width: 986px) {
  .porposalInput {
    height: 200px;
  }
  .add-proposal {
    width: 100%;
  }
}
</style>
<!-- // -user_id,
// -title,
// -description,
// -skills required,
// -budget  -->
